import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons
// import Weekend from "@material-ui/icons/Weekend";
import Home from "@material-ui/icons/Home";
import Business from "@material-ui/icons/Business";
import AccountBalance from "@material-ui/icons/AccountBalance";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import { fetchFaq } from "api/notification/index";

import pricingPageStyle from "assets/jss/material-dashboard-pro-react/views/pricingPageStyle.jsx";
import { withRouter } from "react-router-dom";

class FaqPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      description: ""
    };
  }

  componentDidMount() {
    fetchFaq()
      .then(response => {
        if (response != null) {
          this.setState({
            open: true,
            description: response.data.results[0].description
          });
        }
      })
      .catch(error => {
        //this.props.pushToken(error);
        this.props.history.push("/pages/login#logout");
      });
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={6}>
            <h2 className={classes.title}>FAQ EDTP 3.0</h2>
            <h5 className={classes.title}>{this.state.description}</h5>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

FaqPage.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withRouter(withStyles(pricingPageStyle)(FaqPage));
